export default __webpack_public_path__ + "static/media/37.bb1d681b.jpg";